export const formatCompanyTaxNumber = (input: string) => {
  if (input.length > 5) {
    return input.replace(/^(\d{3})(\d{2})(\d{1,5}).*$/, '$1-$2-$3');
  }
  if (input.length > 3) {
    return input.replace(/^(\d{3})(\d{1,2}).*$/, '$1-$2');
  }
  return input;
};

export const deformatCompanyTaxNumber = (input: string) => {
  return input.replace(/\D/g, '');
};

// 주민등록번호
export const formatResidentRegistrationNumber = (input: string) => {
  if (input.length > 6) {
    return input.replace(/^(\d{6})(\d{1,7}).*$/, '$1-$2');
  }
  return input;
};

// 주민등록번호 포맷팅 해제 (숫자만 추출)
export const deformatResidentRegistrationNumber = (input: string) => {
  return input.replace(/\D/g, '');
};

export const displayCounterPartNumber = (input: string) => {
  if (input.length === 10) {
    return formatCompanyTaxNumber(input);
  } else if (input.length === 13) {
    return formatResidentRegistrationNumber(input);
  }
  return input;
};

export const formatPhoneNumberWithHyphen = (input: string) => {
  // 3-4-4 패턴으로 통일
  if (input.length <= 3) {
    return input.length === 3 ? input + '-' : input;
  }
  if (input.length <= 7) {
    const formatted = input.replace(/(\d{3})(\d{1,4})/, '$1-$2');
    return input.length === 7 ? formatted + '-' : formatted;
  }
  return input.replace(/(\d{3})(\d{4})(\d{1,4})/, '$1-$2-$3');
};
